<template>
  <AnomalyComponent />
</template>
<script>
// @ is an alias to /src
import AnomalyComponent from "@/sections/voiceplus/components/AnomalyComponent.vue";
import config from "@/config";

export default {
  name: "Anomaly",
  components: {
    AnomalyComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
